module.exports = __webpack_public_path__ + "img/hot.6dd2ddd1.png";